import React from 'react';
import { useTranslation } from 'react-i18next';

// import { Container } from './styles';

const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  return <h1>{t('screens.reports')}</h1>;
};

export default Dashboard;
